/**
 * Colors of the new design that are not part of the MUI palette.
 * Names mirror the `--nd-*` tokens of the new-design kit (multi-app `ui/new-design/styles.css`).
 */
const DESIGN_COLORS = {
	/** `--nd-border` (slate-200): card and subsection borders. */
	border: '#e2e8f0',
	/** `--nd-border-hover` (slate-300): dashed border of the "Add tag" button. */
	borderHover: '#cbd5e1',
	/** `--nd-text-slate`: tag chip text. */
	slate: '#475569',
	/** `--nd-border-soft` (slate-100): row dividers, quiet hover backgrounds, count badge. */
	borderSoft: '#f1f5f9',
	/** `--nd-bg` (slate-50): hovered file row background. */
	surfaceMuted: '#f8fafc',
	/** `--nd-dark`: selection toolbar background. */
	dark: '#0f172a',
	/** `--nd-dark-2`: hovered dark button. */
	dark2: '#1e293b',
	/** End color of the video thumbnail placeholder gradient (slate-700). */
	slate700: '#334155',
	/** `--nd-text-strong`: strongest text. */
	strong: '#0f172a',
	/** `--nd-text-muted`: muted text (same as `colorLabel`). */
	muted: '#64748b',
	/** `--nd-text-faint`: faint text and icons. */
	faint: '#94a3b8',
	/** Outer ring of the keyboard focus indicator (`--nd-focus-ring`). */
	focusRing: 'rgba(100, 116, 139, 0.55)',
} as const;

export default DESIGN_COLORS;
